import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { TextStyles } from '@payler/ui-theme';
import { SentryErrorBoundary } from '@payler/ui-components';
import 'dayjs/locale/en';
import 'dayjs/locale/ru';
import { Outlet } from 'react-router-dom';
import { Logo } from '../../components/Logo/Logo';
import { useTranslation } from 'react-i18next';
import React, { useCallback, useEffect } from 'react';
import { css } from '@emotion/react';
import ErrorPage from '../../pages/ErrorPage';
import { useEnableSentry } from '../../hooks/use-enable-sentry';

const boxStyle = css`
  min-height: var(--window-inner-height);
`;

export const AuthLayout: React.FC = () => {
  const enableSentry = useEnableSentry();

  const syncWindowInnerHeight = useCallback(() => {
    document.documentElement.style.setProperty(
      '--window-inner-height',
      `${window.innerHeight}px`,
    );
  }, []);

  useEffect(() => {
    syncWindowInnerHeight();
    window.addEventListener('resize', syncWindowInnerHeight);
    return () => {
      window.removeEventListener('resize', syncWindowInnerHeight);
    };
  }, [syncWindowInnerHeight]);

  return (
    <Flex css={boxStyle}>
      <Box
        display={{ sm: 'block', base: 'none' }}
        bg="menuBG"
        w="60%"
        pl={1}
        pr={1}
      >
        <ImageBlock />
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        flex="1"
        p={{ base: 2, sm: 10 }}
        bg="secondary.500"
      >
        <AuthHeader />
        <SentryErrorBoundary errorPage={<ErrorPage />} enableSentry={enableSentry}>
          <Flex minW={40} flex="1">
            <Outlet />
          </Flex>
        </SentryErrorBoundary>
      </Box>
    </Flex>
  );
};

const ImageBlock = () => {
  return (
    <Flex
      h="100%"
      justifyContent="center"
      direction="column"
      align="center"
      className="container"
    >
      <Image src="/assets/png/authImage.png" />
      <ImageTextBlock />
    </Flex>
  );
};

const AuthHeader = () => {
  return (
    <Flex p="0" justifyContent="space-between">
      <Logo m={{ base: 0, sm: 0 }} ml={0} />
    </Flex>
  );
};

const ImageTextBlock = () => {
  const { t } = useTranslation(['auth']);
  return (
    <Flex mt={9} direction="column" textAlign="center">
      <Text textStyle={TextStyles.h1} color="primary.500">
        {t('auth:imageTitle')}
      </Text>
      <Text textStyle={TextStyles.BodyText16Regular} color="primary.400">
        {t('auth:imageSubtitle')}
      </Text>
    </Flex>
  );
};

export default AuthLayout;
